import { Component } from '@angular/core';
import { ROUTE_URLS } from '../../app.routes.names';
import { ContentfulService } from '../../../services/contentful.service';
import { MetaService } from '../../../services/meta-service.service';

@Component({
  selector: 'app-international-sms',
  templateUrl: './international-sms.component.html',
  styleUrls: ['./international-sms.component.scss']
})
export class InternationalSmsComponent {
  public contentfulData: any;
  public countries: any;
  public filteredCountries: any;
  public letters: Array<string> = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P' , 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  public selected = 'A';
  public ROUTE_URLS = ROUTE_URLS;

  constructor(private contentful: ContentfulService, private metaService: MetaService) {
    this.metaService.createCanonicalUrl();
    this.contentfulData = this.contentful.getContent('internationalSms').subscribe((data) => {
      if (data){
        this.countries = data;
        this.filteredCountries = data.filter((country) => country.fields.country.startsWith('A') === true);
      }
    });
  }
  public filterCountries(filterLetter: string): void{
    this.filteredCountries = this.countries.filter((country) => country.fields.country.startsWith(filterLetter) === true);
  }
}
